export const SkeletonTable = () => (
  <div className="bg-p400 rounded-md mt-3 h-[80vh] overflow-y-scroll no-scrollbar">
    <table className="w-full">
      <thead>
        <tr className="h-12">
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left"></th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left">
            Instrument
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left"></th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left">
            Order ID
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left">
            Executed Time
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-center">
            Type
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-center">
            Product
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-center">
            Quantity
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-center">
            Avg price
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-left">
            Status
          </th>
          <th className="px-4 py-3 text-xs font-medium text-n700 text-center">
            Reason
          </th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 12 }).map((_, index) => (
          <tr key={index} className="h-12 border-b-2 border-n100">
            {Array.from({ length: 11 }).map((_, cellIndex) => (
              <td key={cellIndex} className="px-4 py-3">
                <div className="h-4 bg-n200 rounded animate-pulse"></div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
